module.exports = __webpack_public_path__ + "static/media/22.c8cdd2a2.mp3";